import { EOfferStatusData } from 'shared/types/offersHistory';
import { IHouseOfferHistoryV4Schema } from '../../repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryV4Schema';

export const getOfferDeactivatedLabel = (offer: IHouseOfferHistoryV4Schema): string | null => {
  if (offer.status === EOfferStatusData.Deactivated) {
    return 'Снято с публикации';
  }

  return null;
};
